(function () {
  var ROOT_IDS = ['cc-customizer-progress', 'plush-clone-customizer'];

  function readHeaderOffset() {
    var gap = 16;
    var offset = 0;

    document.querySelectorAll('.announcement-bar').forEach(function (bar) {
      var rect = bar.getBoundingClientRect();
      if (rect.height > 0 && rect.top <= 2) offset = Math.max(offset, rect.bottom);
    });

    var fixedArea = document.querySelector('.page-header_fixed-area');
    if (fixedArea) {
      if (document.body.classList.contains('page-header--fixed')) {
        offset = Math.max(offset, fixedArea.getBoundingClientRect().bottom);
      } else if (fixedArea.offsetHeight > 0) {
        offset = Math.max(offset, fixedArea.offsetHeight);
      }
    }

    if (offset <= 0) {
      var pageHeaderVal = parseFloat(
        getComputedStyle(document.body).getPropertyValue('--page-header-height')
      );
      if (Number.isFinite(pageHeaderVal) && pageHeaderVal > 0) offset = pageHeaderVal;
    }
    if (offset <= 0) {
      var totalVal = parseFloat(
        getComputedStyle(document.body).getPropertyValue('--header-total-height')
      );
      if (Number.isFinite(totalVal) && totalVal > 0) offset = totalVal;
    }

    return Math.max(Math.ceil(offset) + gap, 72);
  }

  function readAnnouncementOffset() {
    var offset = 0;
    document.querySelectorAll('.announcement-bar').forEach(function (bar) {
      var rect = bar.getBoundingClientRect();
      if (rect.height > 0 && rect.top <= 2) offset = Math.max(offset, rect.bottom);
    });
    return Math.ceil(offset);
  }

  function readPlushStuckTop() {
    return readAnnouncementOffset();
  }

  function isPlushFormHeaderStuck() {
    return document.body.classList.contains('pcc-plush-form-header-stuck');
  }

  function initPlushStickyHeaderNav(root) {
    if (root.id !== 'plush-clone-customizer') return;
    var sentinel = root.querySelector('.pcc-sticky-sentinel');
    if (!sentinel) return;

    document.body.classList.add('pcc-plush-customizer-page');

    var isStuck = false;
    var scrollRaf = 0;
    var headerWrapper = document.querySelector('.sticky-header-wrapper');

    function restoreHeaderSpacer() {
      if (!headerWrapper) return;
      var stickyBlock = document.querySelector('sticky-block[data-ref-block=".page-header_fixed-area"]');
      if (
        stickyBlock &&
        stickyBlock.height &&
        document.body.classList.contains('page-header--fixed')
      ) {
        headerWrapper.style.height = stickyBlock.height + 'px';
        document.body.style.setProperty('--page-header-height', stickyBlock.height + 'px');
      } else {
        headerWrapper.style.removeProperty('height');
        document.body.style.removeProperty('--page-header-height');
      }
    }

    function updatePlushHeaderStuck() {
      scrollRaf = 0;
      var anchorTop = readHeaderOffset();
      var nextStuck = sentinel.getBoundingClientRect().bottom <= anchorTop + 0.5;

      if (nextStuck === isStuck) return;
      isStuck = nextStuck;
      document.body.classList.toggle('pcc-plush-form-header-stuck', isStuck);

      if (isStuck) {
        var stuckTop = readPlushStuckTop();
        root.style.setProperty('--pcc-sticky-offset', stuckTop + 'px');
        root.style.setProperty('--pcc-announcement-offset', stuckTop + 'px');
        document.body.style.setProperty('--page-header-height', '0px');
        if (headerWrapper) headerWrapper.style.height = '0px';
        return;
      }

      syncStickyProgressMetrics(root);
      restoreHeaderSpacer();
    }

    function queuePlushHeaderStuck() {
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(updatePlushHeaderStuck);
    }

    window.addEventListener('scroll', queuePlushHeaderStuck, { passive: true });
    window.addEventListener('resize', queuePlushHeaderStuck);
    queuePlushHeaderStuck();
  }

  function syncStickyProgressMetrics(root) {
    var progressBar = root.querySelector('.pcc-progress');
    if (!progressBar) return 0;
    var stickyHeader = root.querySelector('.pcc-sticky-header');
    var stickyEl = stickyHeader || progressBar;
    var headerOffset =
      root.id === 'plush-clone-customizer' && isPlushFormHeaderStuck()
        ? readPlushStuckTop()
        : readHeaderOffset();
    root.style.setProperty('--pcc-sticky-offset', headerOffset + 'px');
    root.style.setProperty('--pcc-announcement-offset', readAnnouncementOffset() + 'px');
    root.style.setProperty('--pcc-progress-height', stickyEl.offsetHeight + 'px');
    return headerOffset;
  }

  function initStickyProgress(root) {
    var progressBar = root.querySelector('.pcc-progress');
    if (!progressBar) return;

    syncStickyProgressMetrics(root);
    setTimeout(function () {
      syncStickyProgressMetrics(root);
    }, 150);
    setTimeout(function () {
      syncStickyProgressMetrics(root);
    }, 600);

    var scrollRaf = 0;
    function onScrollSync() {
      if (scrollRaf) return;
      scrollRaf = window.requestAnimationFrame(function () {
        scrollRaf = 0;
        syncStickyProgressMetrics(root);
      });
    }

    window.addEventListener('resize', function () {
      syncStickyProgressMetrics(root);
    });
    window.addEventListener('orientationchange', function () {
      syncStickyProgressMetrics(root);
    });
    window.addEventListener('scroll', onScrollSync, { passive: true });

    var headerObserver = new MutationObserver(function () {
      syncStickyProgressMetrics(root);
    });
    headerObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style'],
    });

    initPlushStickyHeaderNav(root);
  }

  var CHECK_SVG =
    '<svg class="progress__check" viewBox="0 0 24 24" fill="none" stroke="#FFF" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';

  function findProgressRoot() {
    var cloneRoot = document.getElementById('plush-clone-customizer');
    if (cloneRoot) {
      var cloneBar = cloneRoot.querySelector('.pcc-progress');
      if (cloneBar) return cloneBar;
    }
    var legacyRoot = document.getElementById('cc-customizer-progress');
    if (legacyRoot) {
      var legacyBar = legacyRoot.querySelector('.pcc-progress');
      if (legacyBar) return legacyBar;
    }
    return document.querySelector('.pcc-progress');
  }

  function renderSteps(currentStep) {
    var progressRoot = findProgressRoot();
    if (!progressRoot) return;
    progressRoot.querySelectorAll('.progress__step').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-step'), 10);
      var wrap = el.closest('.progress__step-wrap');
      el.classList.remove('is-done', 'is-current');
      if (wrap) wrap.classList.remove('is-done', 'is-current');
      el.innerHTML = String(n);
      if (n < currentStep) {
        el.classList.add('is-done');
        el.innerHTML = CHECK_SVG;
        if (wrap) wrap.classList.add('is-done');
      } else if (n === currentStep) {
        el.classList.add('is-current');
        if (wrap) wrap.classList.add('is-current');
      }
    });
    progressRoot.querySelectorAll('.progress__line').forEach(function (el) {
      var n = parseInt(el.getAttribute('data-after'), 10);
      el.classList.toggle('is-done', n < currentStep);
    });
  }

  window.CC_WIREFRAME_PROGRESS = {
    readHeaderOffset: readHeaderOffset,
    syncStickyProgressMetrics: syncStickyProgressMetrics,
    renderSteps: renderSteps,
    getScrollAnchorOffset: function (root) {
      if (!root) return 120;
      syncStickyProgressMetrics(root);
      var stickyHeader = root.querySelector('.pcc-sticky-header');
      var progressBar = root.querySelector('.pcc-progress');
      var barHeight = stickyHeader
        ? stickyHeader.offsetHeight
        : progressBar
          ? progressBar.offsetHeight
          : 80;
      var headerGap =
        root.id === 'plush-clone-customizer' && isPlushFormHeaderStuck()
          ? readPlushStuckTop()
          : readHeaderOffset();
      return headerGap + barHeight + 24;
    },
    getScrollOffsetForLegacy: function () {
      var root =
        document.getElementById('cc-customizer-progress') ||
        document.getElementById('plush-clone-customizer');
      if (!root || root.style.display === 'none') return 0;
      return window.CC_WIREFRAME_PROGRESS.getScrollAnchorOffset(root);
    },
  };

  ROOT_IDS.forEach(function (id) {
    var root = document.getElementById(id);
    if (root) initStickyProgress(root);
  });
})();
